import React from "react";
import { ErrorBoundary } from "@sscs/ui";
import IssueChanges from "../issuesDiff/issueChanges/IssueChanges";
import { useVersionDiffContext } from "./VersionDiff";
const IssueChangesTab = () => {
    const { stats } = useVersionDiffContext();
    return (React.createElement(ErrorBoundary, { key: "changes" },
        React.createElement(IssueChanges, { stats: stats })));
};
export default IssueChangesTab;
//# sourceMappingURL=IssueChangesTab.js.map